module.exports = __webpack_public_path__ + "img/calendar.4ba7dae2.png";